export default {
  state: {
    customerText: '',
    customerRegisterNum: '',
    customerVisible: false,
    resolvePromise: null,
    rejectPromise: null
  },
  mutations: {
    CUSTOMER_TEXT (state : any, text : string) {
      state.customerRegisterNum = ''
      state.customerText = text
      state.customerVisible = true
    },
    CUSTOMER_VISIBLE (state : any, registerNum : string) {
      state.customerText = ''
      state.customerRegisterNum = registerNum
      state.customerVisible = true
    },
    CUSTOMER_SELECT (state : any, data: any) {
      state.customerVisible = false
      state.resolvePromise(data)
    },
    CUSTOMER_CANCEL (state : any, data: any) {
      state.customerVisible = false
      state.rejectPromise('cancel')
    }
  },
  actions: {
    customer_text (context : any, text : string) {
      context.commit('CUSTOMER_TEXT', text)
      return new Promise((resolve, reject) => {
        context.state.resolvePromise = resolve
        context.state.rejectPromise = reject
      })
    },
    customer_contracts (context : any, registerNum : string) {
      context.commit('CUSTOMER_VISIBLE', registerNum)
      return new Promise((resolve, reject) => {
        context.state.resolvePromise = resolve
        context.state.rejectPromise = reject
      })
    },
    customer_select (context : any, data : any) {
      context.commit('CUSTOMER_SELECT', data)
    },
    customer_cancel (context : any) {
      context.commit('CUSTOMER_CANCEL')
    }
  }
}
